import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

export interface RecognizeMedicationResponse {
  name: string;
  quantity?: number;
  unit?: string;
  scheduledLdt: string; // local datetime string (no Z suffix)
  originalText?: string;
}

export interface RecognizeMedicationDto {
  text: string;
  contextDate: string; // ISO String (YYYY-MM-DDTHH:mm:ss.sssZ)
  force?: boolean;
}

export interface RecognizeMedicationResult {
  suggestedTitle: string;
  items: RecognizeMedicationResponse[];
}

export interface CreateMedicationEventsBulkDto {
  items: RecognizeMedicationResponse[];
  calendarId?: number;
  rawInput?: string;
  scheduledLdt?: string; // local datetime string (no Z suffix)
  title?: string;
  isCompleted?: boolean;
}

class MedicationsAnalyzerService {
  private readonly BASE_URL = '/ai/medications-analyzer';

  async recognize(payload: RecognizeMedicationDto, clientId?: string | number): Promise<RecognizeMedicationResult> {
    const url = clientId
      ? `/client/${clientId}${this.BASE_URL}/extract`
      : `${this.BASE_URL}/extract`;
    const response = await api.post<ApiResponse<RecognizeMedicationResult>>(url, payload);
    return unwrapApiResponse<RecognizeMedicationResult>(response);
  }

  async createEventsBulk(payload: CreateMedicationEventsBulkDto): Promise<any[]> {
    const response = await api.post<ApiResponse<any[]>>(
      '/calendars/events/medication/bulk',
      payload
    );
    return unwrapApiResponse<any[]>(response);
  }

  async createEventsComplex(payload: CreateMedicationEventsBulkDto, clientId?: string | number): Promise<any> {
    const url = clientId
      ? `/client/${clientId}/calendar/events/medication/complex`
      : '/calendars/events/medication/complex';
    const response = await api.post<ApiResponse<any>>(url, payload);
    return unwrapApiResponse<any>(response);
  }

  async updateEventsComplex(eventId: number, payload: CreateMedicationEventsBulkDto): Promise<any> {
    const response = await api.patch<ApiResponse<any>>(`/calendars/events/${eventId}/medication/complex`, payload);
    return unwrapApiResponse<any>(response);
  }
}

export const medicationsAnalyzerService = new MedicationsAnalyzerService();
